import actionType from './actionType';
import fetchHowToBuyProductDetails from './fetchHowTobuyProductDetails';
import { howToBuyProductActionType } from '../../actionTypes';

export default (action: string, payload?: Object) => (dispatch) => {
  switch (action) {
    case actionType.redirectToHTBProduct:
      const { referralUrl } = payload || {};
      return dispatch({
        type: howToBuyProductActionType.REDIRECT_HOW_TO_BUY_PRODUCT,
        payload: {
          referralUrl,
        },
      });
    case actionType.initHTBProductScreen:
      const { campaignId, lenderId, handle, productId } = payload || {};
      return dispatch(
        fetchHowToBuyProductDetails({
          campaignId,
          lenderId,
          handle,
          productId,
        }),
      );
    default:
      console.error(`Handle Case for ${action}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./actions/howToBuyProductActions/index.js